import React from 'react';
import { Row, Col } from 'react-bootstrap';
import Skeleton from '../../../../common/skeleton';
import '../coverageHistory.scss';

const CoverageHistorySkeleton = () => {
  return (
    <>
      {[1, 2, 3].map((index) => (
        <div key={index}>
          <Row>
            <Col className="">
              <div>
                <div className="skeletonClass">
                  <Skeleton
                    count={1}
                    height={30}
                    width={360}
                    className="plan-details-skeleton"
                  />
                </div>
              </div>
            </Col>
          </Row>
          {[1, 2, 3, 4].map((index) => (
            <Row key={index} className="skeleton-info">
              <Col xs={6}>
                <Skeleton
                  count={1}
                  height={20}
                  width={155}
                  className="plan-details-skeleton"
                />
              </Col>
              <Col xs={6}>
                <Skeleton
                  count={1}
                  height={20}
                  width={155}
                  className="plan-details-skeleton"
                />
              </Col>
            </Row>
          ))}
        </div>
      ))}
    </>
  );
};
export default CoverageHistorySkeleton;
